<template>
	<div class="activitya_index">
		<img class="activitya_img" v-if="activityInfo.activityUrl" :src="activityInfo.activityUrl" alt="">
		<van-button type="warning" class="bind-btn" @click="handleProduct">绑定产品 获取奖励</van-button>
		<!-- <div class="reward-record" @click="handleReward">Reward</div> -->
		<van-popup v-model="showScanner" position="bottom" :style="{ height: '100%' }">
			<barcode-scanner v-if="showScanner" @on-scan-success="onScanSuccess" @close="showScanner = false" scanType="activity" />
		</van-popup>
	</div>
</template>

<script>
import BarcodeScanner from '@/components/BarcodeScanner.vue';
import { queryCodeApi } from '@/api'
import { Toast } from 'vant'
import { mapState } from 'vuex'
export default {
	name: 'Activity',
	components: {
		BarcodeScanner
	},
	data() {
		return {
			showScanner: false
		};
	},
	created() {
		if (localStorage.getItem('linkUrl')) {
			localStorage.removeItem('linkUrl')
		}
	},
	computed: {
    ...mapState({
      activityInfo: 'activityInfo'
    })
  },
	methods: {
		handleProduct() {
			this.showScanner = true;
		},
		onScanSuccess(code) {
			this.showScanner = false;
			// 在这里，您可以根据需要处理条形码，例如验证它或将其发送到服务器
			// 然后导航到另一个页面
			Toast.loading({
				message: 'loading...',
				forbidClick: true,
				duration: 0
			})
			queryCodeApi(code).then(res => {
				Toast.clear()
				window.localStorage.setItem('productInfo', JSON.stringify(res.data))
				this.$router.push({ path: '/activityProduct', query: { barcode: code } })
			}).catch(err => {
				// Toast.clear()
			})
		},
		handleReward() {
			this.$router.push('/rewardRecord')
		}
	}
}
</script>

<style lang="less">
.activitya_index {
	width: 100%;
	height: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	flex-direction: column;
	position: relative;
	.activitya_img {
		width: 93%;
		height: 96%;
	}
	.bind-btn {
		width: 80%;
		position: absolute;
		bottom: 36px;
		background-color: #ee541b;
		border-radius: 16px;
		border: none;
	}
	.reward-record {
		position: absolute;
		right: 0;
		top: 30px;
		padding: 6px 16px;
		color: #fff;
		background-color: #7f7f7f;
		border-top-left-radius: 10px;
		border-bottom-left-radius: 10px;
	}
}
</style>